import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import { cloneValue, expectObject, readString, splitKnown } from "../utils";

export class ProductVersionLabelColorModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    colorChart: { label: "Color Chart", fieldType: "text" },
    colorName: { label: "Color Name", fieldType: "text" },
    colorHex: { label: "Color Hex", fieldType: "color" },
    techpackTextHex: { label: "Techpack Text Hex", fieldType: "color" },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  colorChart!: string;
  colorName!: string;
  colorHex!: string;
  techpackTextHex!: string;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("colorChart", "");
    this.defineObservableValue("colorName", "");
    this.defineObservableValue("colorHex", "");
    this.defineObservableValue("techpackTextHex", "");
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product label color");
    this.colorChart = readString(source, "colorChart");
    this.colorName = readString(source, "colorName");
    this.colorHex = readString(source, "colorHex");
    this.techpackTextHex = readString(source, "techpackTextHex");
    this.extra = splitKnown(source, [
      "colorChart",
      "colorName",
      "colorHex",
      "techpackTextHex",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.colorChart ? { colorChart: this.colorChart } : {}),
      ...(this.colorName ? { colorName: this.colorName } : {}),
      ...(this.colorHex ? { colorHex: this.colorHex } : {}),
      ...(this.techpackTextHex
        ? { techpackTextHex: this.techpackTextHex }
        : {}),
    };
  }
}
